import type { FC } from 'react';
import { useMemo } from 'react';

import StyledList from 'components/UI/StyledList';

import { useDeviceList } from './hooks/useDeviceList';
import styles from './styles.module.scss';

const DevicePermission: FC = () => {
    const deviceList = useDeviceList();

    const listItems = useMemo(() => {
        return deviceList.map(({ content, icon }) => {
            return {
                content,
                marker: icon,
            };
        });
    }, [deviceList]);

    return <StyledList className={styles.wrapper} listItems={listItems} />;
};

export default DevicePermission;
